import React from 'react';
import './GuestSelection.css';

const GuestSelection = ({ guests, onGuestsChange, onClose }) => {
  const handleUpdate = (type, delta) => {
    const currentCount = guests[type] || 0;
    const newCount = Math.max(0, currentCount + delta);
    
    if (type === 'adults' && newCount < 1) {
      return; // Must have at least one adult
    }
    
    onGuestsChange({ ...guests, [type]: newCount });
  };

  const totalGuests = guests.adults + guests.children + guests.infants;

  return (
    <div className="guest-selection-backdrop" onClick={onClose}>
      <div className="guest-selection-content" onClick={(e) => e.stopPropagation()}>
        <div className="guest-selection-header">
          <button className="close-button white-arrow" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 4L8 12L16 20" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <h2 className="guest-selection-title">Guests</h2>
          <div className="header-placeholder"></div>
        </div>
        <div className="guest-selection-body">
          <div className="guest-type-row">
            <div className="guest-type-info">
              <h3>Adults</h3>
              <p>Ages 18+</p>
            </div>
            <div className="guest-stepper">
              <button onClick={() => handleUpdate('adults', -1)} disabled={guests.adults <= 1}>−</button>
              <span>{guests.adults}</span>
              <button onClick={() => handleUpdate('adults', 1)}>+</button>
            </div>
          </div>
          <div className="guest-type-row">
            <div className="guest-type-info">
              <h3>Children</h3>
              <p>Ages 2-17</p>
            </div>
            <div className="guest-stepper">
              <button onClick={() => handleUpdate('children', -1)} disabled={guests.children <= 0}>−</button>
              <span>{guests.children}</span>
              <button onClick={() => handleUpdate('children', 1)}>+</button>
            </div>
          </div>
          <div className="guest-type-row">
            <div className="guest-type-info">
              <h3>Infants</h3>
              <p>Under 2</p>
            </div>
            <div className="guest-stepper">
              <button onClick={() => handleUpdate('infants', -1)} disabled={guests.infants <= 0}>−</button>
              <span>{guests.infants}</span>
              <button onClick={() => handleUpdate('infants', 1)}>+</button>
            </div>
          </div>
        </div>
        <div className="guest-selection-footer">
            <button className="done-button" onClick={onClose}>
                Done
            </button>
        </div>
      </div>
    </div>
  );
};

export default GuestSelection; 